import plugin from 'tailwindcss/plugin';

const table = plugin.withOptions(function () {
	return function ({ addComponents, theme, e }) {
		const borderRadiusDefault = theme('borderRadius.none');

		const colors = {
			dark: theme('textColor.dark.primary'),
			ui25: theme('colors.ui.25'),
			ui75: theme('colors.ui.75'),
			ui100: theme('colors.ui.100'),
			white: theme('colors.white'),
		};

		const tableRowsClass = 'table-rows';

		addComponents({
			[`.${e('table-container')}, table`]: {
				backgroundColor: `var(--table-cell-color-background, ${colors.white})`,
				borderRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
			},

			['table']: {
				boxShadow: `var(--card-elevation, ${theme('elevations')[1].boxShadow})`,
			},

			['th']: {
				color: `var(--table-header-color-text, ${colors.dark})`,
				backgroundColor: `var(--table-header-color-background, ${colors.ui25})`,
				borderColor: `var(--table-row-divider-color, ${colors.ui100})`,
				textAlign: 'left',
			},

			[`.${e(tableRowsClass)}, tr`]: {
				borderColor: `var(--table-row-divider-color, ${colors.ui100})`,
				color: `var(--table-cell-color-text, ${colors.dark})`,
			},

			['tr']: {
				borderBottom: `1px solid var(--table-row-divider-color, ${colors.ui100})`,
			},

			['td, th']: {
				padding: '0.75rem 1rem',
				minWidth: theme('width.32'),
			},

			['tr:first-child > th:first-child']: {
				borderTopLeftRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
			},

			['tr:first-child > th:last-child']: {
				borderTopRightRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
			},

			['tr:last-child > th:first-child']: {
				borderBottomLeftRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
			},

			[`.${e('table-header')}`]: {
				backgroundColor: `var(--table-header-color-background, ${colors.ui25})`,
				borderColor: `var(--table-row-divider-color, ${colors.ui100})`,
				borderTopRightRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
				borderTopLeftRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
				color: `var(--table-header-color-text, ${colors.dark})`,
			},

			[`.${e('table-row-last')}`]: {
				borderBottomRightRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
				borderBottomLeftRadius: `var(--table-border-radius, ${borderRadiusDefault})`,
			},

			[`.${e('table-row-expanded')}`]: {
				backgroundColor: `var(--table-row-expanded-color-background, ${colors.ui25})`,
				borderColor: `var(--table-row-divider-color, ${colors.ui100})`,
			},

			[`.${e('table-html-cell')} *`]: {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
			},

			[`button.${e(tableRowsClass)}:hover`]: {
				backgroundColor: `var(--table-row-color-background-hover, ${colors.ui75})`,
			},

			[`details.${e(tableRowsClass)}:hover`]: {
				backgroundColor: `var(--table-row-color-background-hover, ${colors.ui75})`,
			},
		});
	};
});

export default table;
